<template>
  <div>
    <vxe-toolbar custom>
      <template v-slot:tools>
        <component v-for="(editor,index) in option.editors" :key="`editor_${index}`" :is="editor.cpt" v-bind="editor.props" v-on="editor.events" />
        <v-btn v-for="(tool,index) in option.tools" :key="`button_${index}`" v-bind="tool.props" v-on="tool.events">{{tool.props.name}}</v-btn>
        <!-- <v-btn color="primary ml-2" text @click="onExport">下载</v-btn> -->
      </template>
    </vxe-toolbar>

    <vxe-table v-bind="option.props" v-on="option.events" ref="xTable">
      <vxe-table-column v-if="!config || config.checkable!==false" type="checkbox" width="34"></vxe-table-column>
      <vxe-table-column-render v-for="(col,index) in option.cols" :key="index" :col="col" />
    </vxe-table>
    <vxe-pager perfect v-bind="option.pagerProps" v-on="option.pagerEvents"></vxe-pager>
  </div>
</template>
<script>
const TableOption = {
  column: { sortable: true }, // 表格列默认配置
  props: { // 表格默认配置
    size: 'mini', // medium, small, mini 
    'max-height': 400,
    border: true,
    'highlight-current-row': true,
    'keyboard-config': { isArrow: true },
    'custom-config': { storage: true },
    'checkbox-config': { reserve: true },
    resizable: true,
  },
  events: {}, // 表格默认事件
  pagerProps: { // 分页默认配置
    size: 'mini',
    'current-page': 1,
    'page-size': 20,
    'page-sizes': [{ label: '20', value: 20 }, { label: '50', value: 50 }, { label: '100', value: 100 }, { label: '全部', value: -1 }],
    // 'auto-hidden': true
  },
  pagerEvents: { // 分页默认事件
    'page-change': 'onPageChange'
  }
};

export default {
  props: {
    config: {
      type: Object,
      default: () => new Object()
    },
    matrix: {
      type: Array,
      default: () => new Array()
    }
  },
  data () {
    return {
      option: {
        cols: [], // 表格列
        tools: [], // 工具栏按钮
        editors: [], // 工具栏编辑框

        props: {}, // 表格配置
        events: {}, // 表格事件
        pagerProps: {}, // 分页配置
        pagerEvents: {}, // 分页事件
      }
    }
  },
  created () { this.init() },
  watch:{
    matrix(){
      this.init()
    }
  },
  methods: {
    init () {
      this.initTableColumn();
      this.initPager();
      this.initTable();
      this.initToolbar();
    },
    initTableColumn () {
      let cols = this.config && this.config.cols;
      if (!cols) {
        cols = [];
        let r0 = this.matrix[0];
        for (let i = 0; i < r0.length; i++) {
          let col = { field: String(i), title: String(r0[i]) }
          this.Utility.deepMerge(col, TableOption.column);
          cols.push(col);
        }
      } else {
        let r0 = this.matrix[0];
        let initCols = (rows) => {
          for (let i = 0; i < rows.length; i++) {
            let row = rows[i];
            if(row.field < 0) row.field = row.field + r0.length; //如果存在row.field为负数的情况（倒序），将其转为正数，
            if (row.field != null && !row.title) row.title = String(r0[row.field]);
            if (row.field != null) row.field = String(row.field);
            this.Utility.deepMerge(row, TableOption.column);
            if (row.children && row.children.length) {
              initCols(row.children);
            }
          }
        }
        initCols(cols);
      }
      this.option.cols = cols;
    },
    initPager () {
      // 初始化分页配置
      let pagerProps = (this.config && this.config.pagerProps) || {};
      pagerProps.total = this.matrix.length - 1;
      this.Utility.deepMerge(pagerProps, TableOption.pagerProps);
      this.option.pagerProps = pagerProps;
      // 初始化分页事件
      // 初始化表格事件(来源于参数)
      if (this.config && this.config.pagerEvents) {
        let events = this.config.pagerEvents;
        let eventKeys = Object.keys(events);
        if (eventKeys.length) {
          eventKeys.forEach(key => {
            let eventValue = events[key];
            if (typeof eventValue == 'function') {
              this.option.pagerEvents[key] = eventValue;
            } else {
              let fn = this[eventValue];
              if (!fn) {
                this.option.pagerEvents[key] = new Function('ξ', eventValue)(this);
              } else {
                this.option.pagerEvents[key] = fn;
              }
            }
          })
        }
      }
      // 初始化表格事件(来源于默认配置)
      if (TableOption.pagerEvents) {
        let events = TableOption.pagerEvents;
        let eventKeys = Object.keys(events);
        if (eventKeys.length) {
          eventKeys.forEach(key => {
            if (!this.option.pagerEvents[key]) {
              let eventValue = events[key];
              if (typeof eventValue == 'function') {
                this.option.pagerEvents[key] = eventValue;
              } else {
                let fn = this[eventValue];
                if (!fn) {
                  this.option.pagerEvents[key] = new Function('ξ', eventValue)(this);
                } else {
                  this.option.pagerEvents[key] = fn;
                }
              }
            }
          })
        }
      }
    },
    initTable () {
      // 初始化属性
      let props = (this.config && this.config.props) || {};
      let data = this.matrix.slice(1, this.option.pagerProps['page-size'] + 1);
      props.data = data;
      if (!props.id) props.id = String(+new Date());
      this.Utility.deepMerge(props, TableOption.props);
      this.option.props = props;
      // 初始化表格事件(来源于参数)
      if (this.config && this.config.events) {
        let events = this.config.events;
        let eventKeys = Object.keys(events);
        if (eventKeys.length) {
          eventKeys.forEach(key => {
            let eventValue = events[key];
            if (typeof eventValue == 'function') {
              this.option.events[key] = eventValue;
            } else {
              let fn = this[eventValue];
              if (!fn) {
                this.option.events[key] = new Function('ξ', eventValue)(this);
              } else {
                this.option.events[key] = fn;
              }
            }
          })
        }
      }
      // 初始化表格事件(来源于默认配置)
      if (TableOption.events) {
        let events = TableOption.events;
        let eventKeys = Object.keys(events);
        if (eventKeys.length) {
          eventKeys.forEach(key => {
            if (!this.option.events[key]) {
              let eventValue = events[key];
              if (typeof eventValue == 'function') {
                this.option.events[key] = eventValue;
              } else {
                let fn = this[eventValue];
                if (!fn) {
                  this.option.events[key] = new Function('ξ', eventValue)(this);
                } else {
                  this.option.events[key] = fn;
                }
              }
            }
          })
        }
      }
    },
    initToolbar () {
      let tools = (this.config && this.config.tools) || [];
      if (!tools.length) return;
      let buttons = tools.filter(tool => !tool.type || tool.type == 'button');
      buttons.forEach(tool => { // name,icon,text,color,class...;    click
        let eventValue = tool.click;
        if (typeof eventValue == 'function') {
          this.option.tools.push({ props: tool, events: { click: eventValue } });
        } else {
          let fn = this[eventValue];
          if (!fn) {
            this.option.tools.push({ props: tool, events: { click: new Function('ξ', eventValue)(this) } });
          } else {
            this.option.tools.push({ props: tool, events: { click: fn } });
          }
        }
      })

      this.option.editors = tools.filter(tool => tool.type == 'editor');
    },

    onPageChange ({ pageSize, currentPage }) {
      this.option.pagerProps['page-size'] = pageSize;
      this.option.pagerProps['current-page'] = currentPage;
      if (pageSize == -1) {
        // let data = [];
        // for (let i = 1; i < this.matrix.length; i++) data.push(this.matrix[i]);
        // this.option.props.data = data;
        this.option.props.data = this.matrix.slice(1);
      } else {
        let from = pageSize * (currentPage - 1) + 1, to = pageSize * currentPage + 1;
        // let data = [];
        // for (let i = from; i < to; i++) data.push(this.matrix[i]);
        // this.option.props.data = data;
        this.option.props.data = this.matrix.slice(from, to);
      }
    },

    updateMatrix (matrix) {
      this.matrix.splice(0, this.matrix.length, ...matrix);
      this.option.pagerProps['current-page'] = 1;
      this.option.pagerProps.total = matrix.length;
      this.onPageChange({ pageSize: this.option.pagerProps['page-size'], currentPage: 1 })
    }
  }
}
</script>
